import { FC } from 'react';

import { Box, Image, Link, Text } from '@bonusly/design-system';

import { GenericAttachment } from '../../types/generic-attachment';

type LinkPreviewMetadataProps = {
	title?: string;
	description?: string;
	siteName?: string;
};

const LinkPreviewMetadata: FC<LinkPreviewMetadataProps> = ({ title, description, siteName }) => (
	<>
		{title && (
			<Text fontWeight="semibold" fontSize="sm" color="text.default" noOfLines={2} data-testid="link-preview-title">
				{title}
			</Text>
		)}
		{description && (
			<Text mt={1} fontSize="xs" color="text.soft" noOfLines={2} data-testid="link-preview-description">
				{description}
			</Text>
		)}
		{siteName && (
			<Text mt={1} fontSize="xs" color="text.softer" data-testid="link-preview-site-name">
				{siteName}
			</Text>
		)}
	</>
);

type LinkPreviewAttachmentProps = {
	attachment: GenericAttachment;
};

export const LinkPreviewAttachment: FC<LinkPreviewAttachmentProps> = ({ attachment }) => {
	if (!attachment.url) {
		return null;
	}

	return (
		<Link href={attachment.url} target="_blank" rel="noopener noreferrer" data-testid="link-preview-link" _hover={{ textDecoration: 'none' }}>
			<Box
				bg="bg.surface"
				borderRadius="lg"
				border="1px solid"
				borderColor="border.default"
				overflow="hidden"
				data-testid="link-preview-frame"
				transition="border-color 0.2s"
				_hover={{ borderColor: 'border.soft' }}
			>
				{attachment.image_url && (
					<Box maxH="12.5rem" overflow="hidden" display="flex" justifyContent="center" bg="bg.subtle">
						<Image src={attachment.image_url} alt="" objectFit="contain" maxW="100%" maxH="12.5rem" data-testid="link-preview-image" />
					</Box>
				)}
				<Box p={3}>
					<LinkPreviewMetadata title={attachment.title} description={attachment.description} siteName={attachment.site_name} />
				</Box>
			</Box>
		</Link>
	);
};
